import React, { useEffect, useRef, useState } from "react";
import "./TicketsPage.css";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { Button, Pagination } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import axios from "axios";
import { MdAdd } from "react-icons/md";
const TicketsPage = () => {
  const dispatch = useDispatch();
  const ticketsList = [
    {
      ticketName: "Login Issue",
      ticketStatus: "Open",
      createdOn: "2024-04-12",
      priority: "High",
    },
    {
      ticketName: "Payment Not Processed",
      ticketStatus: "In Progress",
      createdOn: "2024-04-15",
      priority: "Medium",
    },
    {
      ticketName: "Page Load Error",
      ticketStatus: "Resolved",
      createdOn: "2024-04-18",
      priority: "Low",
    },
    {
      ticketName: "Account Lockout",
      ticketStatus: "Open",
      createdOn: "2024-04-20",
      priority: "High",
    },
    {
      ticketName: "Bug in User Profile Settings",
      ticketStatus: "In Progress",
      createdOn: "2024-04-22",
      priority: "Medium",
    },
    {
      ticketName: "Feature Request - Dark Mode",
      ticketStatus: "Closed",
      createdOn: "2024-04-25",
      priority: "Low",
    },
    {
      ticketName: "Error 500 on Checkout Page",
      ticketStatus: "Open",
      createdOn: "2024-04-28",
      priority: "High",
    },
    {
      ticketName: "Subscription Plan Update",
      ticketStatus: "Resolved",
      createdOn: "2024-04-30",
      priority: "Medium",
    },
    {
      ticketName: "Password Reset Not Working",
      ticketStatus: "Open",
      createdOn: "2024-05-01",
      priority: "High",
    },
    {
      ticketName: "App Crashes on Launch",
      ticketStatus: "In Progress",
      createdOn: "2024-05-03",
      priority: "High",
    },
  ];
  //console.log(ticketsList, "ticketsListticketsList")
  const totalNotifications = useSelector(
    (state) => state.user.totalNotifications
  );
  const userInfo = useSelector((state) => state.user.userInfo);
  const token = useSelector((state) => state.user.token);
  const [notiChecklist, setNotiChecklist] = useState([]);
  const notiUpdated = useSelector((state) => state.user.isnotiupdated);
  const [statusFilter, setStatusFilter] = useState("");
  const [showUnread, setShowUnread] = useState(null);
  const showRef = useRef(null);
  const [isShow, setIsShow] = useState(false);
  const [isAll, setIsAll] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (showRef.current && !showRef.current.contains(event.target)) {
        setIsShow(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const appendIdentifiers = (identifier) => {
    setIsAll(false);
    setNotiChecklist((prevList) =>
      prevList.includes(identifier)
        ? prevList.filter((id) => id !== identifier)
        : [...prevList, identifier]
    );
  };

  const [pageNumber, setPageNumber] = useState(1);

  const NextPage = (event, value) => {
    setPageNumber(value);
  };
  const pageSize = 8;

  const getDaysAgo = (date) => {
    const diffInMs = new Date() - new Date(date);
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const days = Math.floor(diffInMinutes / (60 * 24));
    const hours = Math.floor((diffInMinutes % (60 * 24)) / 60);
    const minutes = diffInMinutes % 60;

    if (days > 0) {
      return `${days} day(s), ${hours} hour(s), ${minutes} minute(s) ago`;
    }
    if (hours > 0) {
      return `${hours} hour(s), ${minutes} minute(s) ago`;
    }
    return `${minutes} minute(s) ago`;
  };

  // const markAllAsRead = async () => {
  //   try {
  //     const response = await axios.put(
  //       `${API}/Notification/MarkAllNotificationsAsRead`,
  //       undefined,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response.data.statusCode == 200) {
  //       dispatch(
  //         fetchNotifications({
  //           PageNumber: pageNumber,
  //           pageSize: 7,
  //           isRead: showUnread,
  //           searchTerm: statusFilter,
  //         })
  //       );
  //       cogoToast.success("All notifications have been marked as read.", {
  //         position: "top-center",
  //       });
  //     } else {
  //       cogoToast.error("Error processing your request.", {
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const markAsRead = async () => {
  //   try {
  //     if (isAll) {
  //       markAllAsRead();
  //       return;
  //     }
  //     if (notiChecklist.length == 0) {
  //       cogoToast.warn("Please select a notification to mark as read.", {
  //         position: "top-center",
  //       });
  //       return;
  //     }
  //     const response = await axios.put(
  //       `${API}/Notification/MarkNotificationsAsRead`,
  //       notiChecklist,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response.data.statusCode == 200) {
  //       dispatch(
  //         fetchNotifications({
  //           PageNumber: pageNumber,
  //           pageSize: 7,
  //           isRead: showUnread,
  //           searchTerm: statusFilter,
  //         })
  //       );
  //       cogoToast.success("Notifications have been marked as read.", {
  //         position: "top-center",
  //       });
  //     } else {
  //       cogoToast.error("Error processing your request.", {
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // useEffect(() => {
  //   dispatch(
  //     fetchNotifications({
  //       PageNumber: pageNumber,
  //       pageSize: 7,
  //       isRead: showUnread,
  //       searchTerm: statusFilter,
  //     })
  //   );
  // }, [pageNumber, showUnread, statusFilter, notiUpdated]);

  // const addUserObject = async (connection, connectionId) => {
  //   if (connection) {
  //     const user = {
  //       ConnectionId: connectionId,
  //       UserType: Number(3),
  //       Identifier: userInfo?.identifier,
  //       Username: userInfo?.firstName + " " + userInfo?.lastName,
  //     };

  //     try {
  //       await connection.invoke("AddUserObject", user);
  //     } catch (error) {}
  //   }
  // };

  // useEffect(() => {
  //   SignalRService.connection.on("ReceiveNotification", (msg) => {
  //     dispatch(
  //       fetchNotifications({
  //         PageNumber: pageNumber,
  //         pageSize,
  //         isRead: showUnread,
  //         searchTerm: statusFilter,
  //       })
  //     );
  //   });
  //   let connection;
  //   const connectToHub = async () => {
  //     try {
  //       const hubConnection = new signalR.HubConnectionBuilder()
  //         .withUrl(`${API}/hubs/notification`, {
  //           accessTokenFactory: () => userInfo.authToken,
  //         })
  //         .withAutomaticReconnect()
  //         .build();
  //       await hubConnection.start();
  //       connection = hubConnection;
  //       connection.on("Connected", (connId) => {
  //         addUserObject(connection, connId);
  //       });
  //       connection.on("ReceiveNotification", (msg) => {
  //         dispatch(
  //           fetchNotifications({
  //             PageNumber: pageNumber,
  //             pageSize,
  //             isRead: showUnread,
  //             searchTerm: statusFilter,
  //           })
  //         );
  //       });
  //       return connection;
  //     } catch (error) {
  //       ////console.log(error);
  //     }
  //   };
  //   connectToHub();
  //   return () => {
  //     if (connection) {
  //       connection.stop();
  //       connection = null;
  //     }
  //   };
  // }, [pageNumber]);

  // const onNotificationClick = (caseIdentifier, message) => {
  //   if (caseIdentifier) {
  //     if (message.includes("FinalizedBySigningRadiologist")) {
  //       dispatch(setAddendumList(false));
  //       dispatch(setFinalizeListTemp(true));
  //     } else if (message.includes("AddendumFinalizedBySigningRadiologist")) {
  //       dispatch(setAddendumList(true));
  //       dispatch(setFinalizeListTemp(false));
  //     } else {
  //       dispatch(setAddendumList(false));
  //       dispatch(setFinalizeListTemp(false));
  //     }
  //     router.push(`/Radiologist/Worklist?identifier=${caseIdentifier}`);
  //   }
  // };

  return (
    <div
      className="ticket-container ticket-page  font-family"
      style={{ padding: "1rem 1rem 0 1rem" , margin:'0px 2rem'}}
    >
      <div
        className="flex justify-between items-start"
        style={{ marginBottom: "1rem", width:'98%'}}
      >
        <h2 className="text-2xl font-bold text-gray-800 ml-[1.2rem]">Tickets</h2>
        <div className="flex gap-x-3">
          <div className="flex bg-white  border-[1px] border-gray-300 text-black rounded-lg">
          <form autocomplete="off"> 
            <input
              onChange={(e) => setStatusFilter(e.target.value)}
              type="text"
              placeholder="Search Tickets..."
              className="bg-white rounded-lg placeholder-slate-400  text-[13px]"
              style={{ padding: "0.35rem", outline: "none" }}
            />
            </form>
            <div ref={showRef} className="relative">
              <button
                onClick={() => setIsShow(!isShow)}
                className="paddingLeftRight paddingYAxis flex items-center gap-x-2 text-xs text-black"
              >
                <span>
                  <FilterListRoundedIcon fontSize="small" />
                </span>
              </button>
              {isShow && (
                <div className="absolute cursor-pointer w-28 border-[1px] bg-white border-gray-300 rounded-lg shadow-lg top-10 z-50 text-black">
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(null);
                    }}
                    className="hover:bg-white rounded-t-lg text-[14px]"
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                    All tickets
                  </div>
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(true);
                    }}
                    className="hover:bg-white text-[14px]"
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                  Unassigned Tickets
                  </div>
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(false);
                    }}
                    className="hover:bg-white rounded-b-lg text-[14px]"
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                  Open Tickets
                  </div>
                </div>
              )}
            </div>
          </div>
          <Button variant="contained" className="float-right flex "> <MdAdd />Create Ticket</Button>
          {/* <button
            // onClick={markAsRead}
            className="paddingLeftRight paddingYAxis shadow-lg rounded-lg flex items-center gap-x-2 text-xs border-[1px] border-gray-400 text-black"
          >
            <span>
              <VisibilityOutlinedIcon fontSize="small" />
            </span>
            <span>Create Ticket</span>
          </button> */}
          {/* <button
            onClick={markAsRead}
            className="paddingLeftRight paddingYAxis shadow-lg rounded-lg flex items-center gap-x-2 text-xs border-[1px] border-gray-400 text-black"
          >
            <span>Mark as Read</span>
          </button> */}
        </div>
      </div>

      {/* Content with flex-grow */}
      <div className="notifications-content">
        {ticketsList.length > 0 && (
          <div className="flex gap-x-3" style={{ paddingLeft: "23px" }}>
            <input type="checkbox" onChange={() => setIsAll(!isAll)} />
            <div className="text-black">Select All</div>
          </div>
        )}
      
        <div className=" flex-1 ">
          <div className="h-full overflow-x-auto  flex-1 mx-8 lg:mx-0 md:mx-8 sm-mx-8 px-6">
            <table className=" w-[100%] gap-y-2 FontFamilyGilroy">
              {/* head */}

              <>
                <thead className="FontFamilyGilroy">
                  <tr className="rounded-lg text-slate-100 text-xs my-3 FontFamilyGilroy">
                    <th className="py-3 px-4 table-left-radius font-normal">
                      Ticket Name
                    </th>
                    <th className="py-3 px-4 font-normal">
                      Ticket Status
                    </th>
                    <th className="py-3 px-4 font-normal">
                      Create Date
                    </th>
                    <th className="py-3 px-4 font-normal">
                      Priority
                    </th>

                  </tr>
                </thead>
                <tbody>
                  {ticketsList?.length > 0 ? (
                    ticketsList?.map((ticket, index) => (
                      <tr
                        key={index} // Adding key here to avoid warning
                        className="w-full border-b border-[#cccccc] FontFamilyGilroy"
                      >
                        <td
                          style={{
                            borderTopLeftRadius: "10px !important",
                            borderBottomLeftRadius: "10px !important",
                          }}
                          className="py-2 px-4"
                        >
                          {ticket.ticketName} {/* Accessing ticket data */}
                        </td>
                        <td className="py-2 px-4">
                          {ticket.ticketStatus} {/* Accessing ticket data */}
                        </td>
                        <td className="py-2 px-4">
                          {ticket.createdOn} {/* Accessing ticket data */}
                        </td>
                        <td className="py-2 px-4">
                          {ticket.priority} {/* Accessing ticket data */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4"> {/* Adjust colSpan to 4 for all columns */}
                        <div className="flex justify-center items-center h-64 text-[var(--table-color)] text-xl">
                          No record found!
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>


            </table>
          </div>
        </div>
      </div>
      <div
        className="flex w-full justify-center items-center gap-2 text-black"
        style={{ marginTop: "1rem" }}
      >
        <Stack spacing={0.5}>
          <Pagination
            count={Math.ceil(totalNotifications / 8)}
            page={pageNumber}
            onChange={NextPage}
            shape="rounded"
            style={{ color: "#A0AEC0" }}
            siblingCount={0}
            boundaryCount={1}
            className="wl-pagination"
          />
        </Stack>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default TicketsPage;
